type CurrencyNumberProps = {
  number: number;
  currency?: 'EUR';
  currencyWeight?:
    | 100
    | 200
    | 300
    | 400
    | 500
    | 600
    | 700
    | 800
    | 900
    | 'bold'
    | 'normal'
    | 'inherit';
  numberWeight?:
    | 100
    | 200
    | 300
    | 400
    | 500
    | 600
    | 700
    | 800
    | 900
    | 'bold'
    | 'normal'
    | 'inherit';
  currencySize?: number | 'inherit';
  numberSize?: number;
  currencyColor?: 'inherit' | 'orange';
  numberColor?: 'inherit' | 'orange';
};

export function CurrencyNumber(props: CurrencyNumberProps): JSX.Element {
  const {
    number,
    currency = 'EUR',
    currencyWeight = 'inherit',
    numberWeight = 'inherit',
    currencySize = 'inherit',
    numberSize = 'inherit',
    currencyColor = 'inherit',
    numberColor = 'inherit'
  } = props;

  return (
    <span>
      <span
        style={{
          fontWeight: numberWeight,
          fontSize:
            typeof numberSize === 'number' ? `${numberSize}em` : numberSize,
          color: numberColor === 'orange' ? '#E86825' : numberColor
        }}
      >
        {Number(number).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}{' '}
      </span>
      <span
        style={{
          fontWeight: currencyWeight,
          fontSize:
            typeof currencySize === 'number'
              ? `${currencySize}em`
              : currencySize,
          color: currencyColor === 'orange' ? '#E86825' : currencyColor
        }}
      >
        {currency}
      </span>
    </span>
  );
}
